module.exports = __webpack_public_path__ + "static/media/worldPin3.b8a5a035.svg";